var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecurrencesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2204_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46429 2.75H14.5357V1.03125C14.5357 0.461914 15.0612 0 15.7143 0C16.3674 0 16.8929 0.461914 16.8929 1.03125V2.75H18.8571C20.5906 2.75 22 3.98105 22 5.5V19.25C22 20.7668 20.5906 22 18.8571 22H3.14286C1.40692 22 0 20.7668 0 19.25V5.5C0 3.98105 1.40692 2.75 3.14286 2.75H5.10714V1.03125C5.10714 0.461914 5.63259 0 6.28571 0C6.93884 0 7.46429 0.461914 7.46429 1.03125V2.75ZM2.35714 19.25C2.35714 19.6281 2.70875 19.9375 3.14286 19.9375H18.8571C19.2893 19.9375 19.6429 19.6281 19.6429 19.25V8.25H2.35714V19.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrencesIcon);
export default __webpack_public_path__ + "static/media/recurrences-icon.8d1e4f0b905ef060ed049c6561be2538.svg";
export { ForwardRef as ReactComponent };